module.exports = __webpack_public_path__ + "static/media/pack-inner.68ae3f26.png";